export default __webpack_public_path__ + "static/media/lion-gen0.418e39f3.png";